import React, { useState } from "react";
import MesaCard from "./MesaCard.js";

import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";

import "./MesaCard.css";
import { useMesa } from "../../../contexto/provider/MesaContext.js";


export default function MesasGrid() {
  const { mesaSeleccionada, mesasDisponibles, seleccionarMesa } = useMesa();
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [mesaPopup, setMesaPopup] = useState(null);

  const handleSeleccionarMesa = (id) => {
     console.log("CLICK MESA:", id);
    seleccionarMesa(id);
    setMesaPopup(id);
    setMostrarPopup(true);

    setTimeout(() => {
      setMostrarPopup(false);
    }, 1500);
  };
  return (
    <>
    <TituloModulo titulo="Mesas Disponibles" />
    
      <div className="mesa-container">
        {mesasDisponibles.map((mesa) => (
          <MesaCard
            key={mesa.id}
            id={mesa.id}
            nombre={mesa.nombre}
            seleccionada={mesaSeleccionada === mesa.id}
            onSelect={handleSeleccionarMesa}
          />
        ))}
      </div>

      {mostrarPopup && (
        <div className="popup-mesa">Mesa {mesaPopup} seleccionada</div>
      )}
    </>
  );
}
